<template>
  <div class="footer">
    <div class="container">
      <div class="footer-grids">
        <div class="col-md-6 footer-grid">
          <h3 style="text-align:center">
            <router-link class="logo-font"
              :to="{ name: 'home', params: {} }">
              Group Blogger
            </router-link>
              A group managed blog service.
          </h3>
        </div>
        <div class="col-md-6 footer-grid">
          <h3>Support</h3>
          <ul>
            <li>
              <router-link class="logo-font" :to="{ name: 'tos', params: {} }">
                Terms of Service
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'privacy', params: {} }">
                Privacy Policy
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'rwvFooter'
}
</script>



// WEBPACK FOOTER //
// src/components/TheFooter.vue